export default function HeaderSkeleton() {
  return (
    <header className="sticky -top-px z-50 h-[80px] w-full">
      <nav className="sticky flex w-screen flex-wrap items-center justify-between border-gray-200 bg-white px-4 py-5 lg:px-6 lg:py-2 dark:bg-gray-800">
        <div className="mx-auto inline-flex w-full max-w-(--breakpoint-xl) justify-between">
          {/* Logo Placeholder */}
          <div className="my-auto h-10 w-40 rounded bg-gray-300 dark:bg-gray-600"></div>

          <div className="inline-flex gap-4">
            <div className="flex items-center lg:order-2">
              <div className="hidden lg:block">
                {/* Placeholder for User Menu or Buttons */}
                <div className="inline-flex items-center gap-4">
                  <div className="h-14 w-14 rounded-full bg-gray-300 dark:bg-gray-600"></div>
                </div>
              </div>

              {/* Placeholder for Burger Menu */}
              <div className="block h-10 w-10 rounded bg-gray-300 lg:hidden dark:bg-gray-600"></div>
            </div>

            {/* Placeholder for Tabs Menu */}
            <div className="hidden w-full items-center justify-between lg:order-1 lg:flex lg:w-auto">
              <div className="flex space-x-4">
                <div className="h-8 w-20 rounded bg-gray-300 dark:bg-gray-600"></div>
                <div className="h-8 w-20 rounded bg-gray-300 dark:bg-gray-600"></div>
                <div className="h-8 w-20 rounded bg-gray-300 dark:bg-gray-600"></div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
}
